import { BehaviorSubject } from 'rxjs';

export class FilterPubDate {
  constructor (
    public pubstartdate: string,
    public pubenddate: string
  ) {}
}

export class FilterStatusModel {
  public status: BehaviorSubject<FilterStatusModel> = new BehaviorSubject(this);

  constructor (
    public query: string = '',
    public sort: string = '',
    public source: string = '',
    public limit: string[] = [],
    public currencyfilter: boolean = true,
    public pubDate: FilterPubDate = {
      pubstartdate: null,
      pubenddate: null
    },
    public lexilemin: string = '',
    public lexilemax: string = ''
  ) {}

  public update (data) {

    for (let prop in data) {
      if (data.hasOwnProperty(prop) && typeof this[prop] !== 'undefined') {
        this[prop] = data[prop];
      }
    }
    this.status.next(this);
  }

  public createUrlObject (): Object {
    let url = {};

    if (this.pubDate['pubstartdate'] && this.pubDate['pubenddate']) {
      url['pubstartdate'] = this.pubDate['pubstartdate'];
      url['pubenddate'] = this.pubDate['pubenddate'];
    }

    url['query'] = this.query;
    url['sort'] = this.sort;

    if (this.limit.length) {
      url['limit'] = this.limit.join('|');
    }

    if (this.source) {
      url['source'] = this.source;
    }

    if (this.lexilemin && this.lexilemax) {
      url['lexilemin'] = this.lexilemin;
      url['lexilemax'] = this.lexilemax;
    }

    url['currencyfilter'] = this.currencyfilter;

    return url;
  }
}
